import { render } from "./AutofillSection.vue?vue&type=template&id=5fea15fc&scoped=true&ts=true"
import script from "./AutofillSection.vue?vue&type=script&lang=ts"
export * from "./AutofillSection.vue?vue&type=script&lang=ts"

import "./AutofillSection.vue?vue&type=style&index=0&id=5fea15fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fea15fc"]])

export default __exports__